<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";

defineProps<{ field: FieldChange }>();
</script>

<template>
  <div class="change horizontal">
    <template v-if="field.old !== null">
      <span class="change-value">{{ field.old }}</span>
      <SvgIcon
        name="arrow/right"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <span class="change-value">{{ field.new }}</span>
  </div>
</template>
